export default __webpack_public_path__ + "static/media/Infosys.8ea49157.png";